<div #bomAddAdditionalComponentsModal class="modal fade" data-backdrop="static" tabindex="-1">
  <div class="modal-dialog modal-dialog-centered modal-md modal-add-additional-components">
    <div class="modal-content no-border border-radius-0">
      <div class="modal-header text-uppercase font-size-16 bg-light-green border-radius-0">
        <div class="modal-title text-color-white">
          <ng-container i18n="@@app.catalogue">Catalogue</ng-container>
        </div>
        <button type="button" (click)="closeModal()" class="close text-color-white opacity-100" data-dismiss="modal" aria-label="Close">
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <div class="display-flex modal-body mx-3 my-2 px-0 catalogue-content flex-column flex-sm-row">
        @if (productsGroups) {
          <div class="col-sm-3 display-flex flex-row flex-sm-column flex-wrap">
            @for (group of productsGroups; track group; let groupIndex = $index) {
              <div
                (click)="selectGroup(groupIndex)"
                class="cursor-pointer d-flex align-items-center border-bottom position-relative bg-blue-gray border-white bg-blue-gray-hover"
                [ngClass]="{'selected-group' : group?.groupName === productsGroups[selectedGroupIndex]?.groupName}"
                >
                <p class="display-inline-block pb-2 pt-2 pl-3 pr-3 m-0 additional-components-category-title">{{ group.groupName }}</p>
              </div>
            }
          </div>
          <div class="row p-1 pl-3 px-3 overflow-y-auto w-100">
            @if (productsGroups && productsGroups[selectedGroupIndex]?.products; as productsList) {
              @for (product of productsList; track product) {
                <div
                  class="py-3 col-md-6 col-lg-6 col-xl-6 d-block article-borders max-height-modal">
                  <div class="display-flex flex-column h-100 justify-content-between">
                    <div>
                      <div class="display-flex justify-content-center py-2">
                        <app-ui-image
                          [src]="product?.reference | catalogProductImage:false | async"
                          [alt]="product?.reference"
                          [height]="140">
                        </app-ui-image>
                      </div>
                      <div class="display-flex font-size-m mx-auto justify-content-around">
                        <p class="mr-1 font-weight-bold">{{ product?.reference }}</p>
                        <p>{{ product?.enumber }}</p>
                      </div>
                    </div>
                    <div class="font-size-xs pb-3">{{ product?.pDescription }}</div>
                    @if (bomModelsAccessories | bomModelByReference : product?.reference; as existingProductInBom) {
                      <app-ui-products-article-counter
                        [numberOfAddedProducts]="existingProductInBom | existingAdditionalComponentsQuantityInCatalogue : adjustedExistingProducts"
                        [currentStateInABom]="existingProductInBom?.quantity"
                        (numberOfProductsChanged)="adjustNumberOfExistingProduct($event, existingProductInBom)"
                      ></app-ui-products-article-counter>
                    } @else {
                      <app-ui-products-article-counter
                        [numberOfAddedProducts]="(addedProducts | additionalComponentsAddedInCatalogue : product?.reference) || 0"
                        (numberOfProductsChanged)="changeNumberOfProducts($event, product)"
                      ></app-ui-products-article-counter>
                    }
                  </div>
                </div>
              }
            }
          </div>
        } @else {
          <div class="m-auto">
            <app-ui-loading minHeight="40"></app-ui-loading>
          </div>
        }
      </div>
      <div class="modal-footer pt-0 no-border">
        <button type="button" (click)="closeModal()"
          class="btn btn-light btn-lg text-uppercase border-rounded font-weight-normal mx-2"
        i18n="@@app.cancel">Cancel</button>
        <button appDisableMultipleClick
          type="button"
          class="btn btn-primary bg-light-blue btn-lg text-uppercase border-rounded mx-2 font-weight-normal"
          [disabled]="addedProducts | noProductsAdded : adjustedExistingProducts"
          (click)="addProducts()">
          <ng-container i18n="@@app.add_products">Add Products</ng-container>
          <!--          <span class="badge bg-light-blue border-solid border-width-2 border-white">{{addedProducts | numberOfAdditionalComponentsInCart}}</span>-->
        </button>
      </div>
    </div>
  </div>
</div>
<app-add-additional-components-from-catalogue-modal
  #confirmationModal
  [productsInCart]="addedProducts"
  [productsWithAdjustedQuantity]="adjustedExistingProducts"
  (confirm)="confirmAddingProducts()"
  (cancel)="returnToCatalogue()">
</app-add-additional-components-from-catalogue-modal>
